import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import { parseDate } from './parseDate';

dayjs.extend(advancedFormat);

export const formatDate = (date: number | Date, format = 'MMM DD, YYYY') =>
  dayjs(new Date(parseDate(date))).format(format);
